import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ContDatatoggle, Row, Column, ContentContainer, Icon, Text } from './DataToggle.styles';
import IcoOnboarding from '../../assets/images/services-icons/user-octagon.svg';
import IcoAnalisis from '../../assets/images/services-icons/note.svg';
import IcoPayServces from '../../assets/images/services-icons/document-text.svg';
import IcoAutom from '../../assets/images/services-icons/candado.svg';
import IcoDispersion from '../../assets/images/services-icons/direct-send.svg';
import IcoMoney from '../../assets/images/services-icons/money-3.svg';
import IcoCC from '../../assets/images/services-icons/card.svg';
import IcoNoti from '../../assets/images/services-icons/message-text.svg';
import IcoSecurity from '../../assets/images/services-icons/shield-tick.svg';
import IcoScoring from '../../assets/images/services-icons/activity.svg';

const Datatoggle = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isEnglish = i18n.language === 'en';

  const serviceRoutes = {
    onboarding: isEnglish ? '/en/onboarding' : '/onboarding',
    creditAnalysis: isEnglish ? '/en/credit-analysis' : '/analisis-crediticio',
    pld: isEnglish ? '/en/anti-money-laundering' : '/pld',
    cardIssuance: isEnglish ? '/en/card-issuance' : '/emision-tarjetas',
    dispersion: isEnglish ? '/en/payment-dispersion' : '/dispersion-pagos',
    notifications: isEnglish ? '/en/notifications' : '/notificaciones',
    collections: isEnglish ? '/en/collections' : '/cobranza',
    payServices: isEnglish ? '/en/pay-services' : '/pago-servicios',
    scoring: isEnglish ? '/en/alternative-scoring' : '/score-alternativo',
    deviceLock: isEnglish ? '/en/device-lock' : '/bloqueo-dispositivos',
  };

  const handleNavigate = (route) => {
    navigate(route);
  };

  return (
    <ContDatatoggle id={'ContDatatoggle'}>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.onboarding)}>
          <ContentContainer>
            <Icon>
              <img src={IcoOnboarding} alt={'UserOnboard'} />
            </Icon>
            <Text>{t('Onboarding Digital')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.pld)}>
          <ContentContainer>
            <Icon>
              <img src={IcoSecurity} alt={'IcoSecurity'} />
            </Icon>
            <Text>PLD</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.creditAnalysis)}>
          <ContentContainer>
            <Icon>
              <img src={IcoAnalisis} alt={'IcoAnalisis'} />
            </Icon>
            <Text>{t('Análisis Crediticio')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.cardIssuance)}>
          <ContentContainer>
            <Icon>
              <img src={IcoCC} alt={'IcoCC'} />
            </Icon>
            <Text>{t('Emisión de tarjetas')}</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.dispersion)}>
          <ContentContainer>
            <Icon>
              <img src={IcoDispersion} alt={'IcoDispersion'} />
            </Icon>
            <Text>{t('Dispersión')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.notifications)}>
          <ContentContainer>
            <Icon>
              <img src={IcoNoti} alt={'IcoNoti'} />
            </Icon>
            <Text>{t('Campaña de notificaciones')}</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.collections)}>
          <ContentContainer>
            <Icon>
              <img src={IcoMoney} alt={'IcoMoney'} />
            </Icon>
            <Text>{t('Cobranza')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.payServices)}>
          <ContentContainer>
            <Icon>
              <img src={IcoPayServces} alt={'IcoPayServces'} />
            </Icon>
            <Text>{t('Pago de servicios')}</Text>
          </ContentContainer>
        </Column>
      </Row>
      <Row>
        <Column onClick={() => handleNavigate(serviceRoutes.scoring)}>
          <ContentContainer>
            <Icon>
              <img src={IcoScoring} alt={'IcoScoring'} />
            </Icon>
            <Text>{t('Score alternativo')}</Text>
          </ContentContainer>
        </Column>
        <Column onClick={() => handleNavigate(serviceRoutes.deviceLock)}>
          <ContentContainer>
            <Icon>
              <img src={IcoAutom} alt={'IcoAutom'} />
            </Icon>
            <Text>{t('Candado de Smartphones')}</Text>
          </ContentContainer>
        </Column>
      </Row>
    </ContDatatoggle>
  );
};

export default Datatoggle;
